import Vue from 'vue'
import Router from 'vue-router'

//
// Components
//
import Home from '@/components/Homepage/Index'

import Cart from '@/components/Cart/Index'

// Item
import Items from '@/components/Products/Index'
import SingleItem from '@/components/Products/SingleItem'
import SingleComposition from '@/components/Products/SingleComposition'

// Account
import Account from '@/components/Account/Index'

// Authentication
import Authenticate from '@/components/Authentication/Index'
import Register from '@/components/Authentication/Register'
import ResetPassword from '@/components/Authentication/ResetPassword'

// Pages
import Terms from '@/components/pages/Terms'
import Faq from '@/components/pages/Faq'
import PageNotFound from '@/components/pages/PageNotFound'
import InternalError from '@/components/pages/InternalError'
import License from '@/components/pages/License'

// Services
import AuthorizationService from '@/services/AuthorizationService'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/uitloggen',
            name: 'logout',
            beforeEnter (to, from, next) {
                AuthorizationService.logout()
                next({ name: 'home' })
            }
        },
        {
            path: '/producten',
            name: 'products',
            component: Items
        },
        {
            path: '/categorieën/:categoryID',
            name: 'category',
            component: Items
        },
        {
            path: '/product/:itemID',
            name: 'product',
            component: SingleItem
        },
        {
            path: '/compositie/:compositionID',
            name: 'composition',
            component: SingleComposition
        },
        {
            path: '/winkelwagen',
            name: 'cart',
            component: Cart,
            beforeEnter: (to, from, next) => {
                if (!AuthorizationService.isUserLoggedIn()) {
                    next({ name: 'login' })
                } else {
                    next()
                }
            }
        },
        {
            path: '/aanmelden',
            name: 'login',
            component: Authenticate
        },
        {
            path: '/registreren',
            name: 'register',
            component: Register
        },
        {
            path: '/account',
            name: 'account',
            component: Account,
            beforeEnter: (to, from, next) => {
                if (!AuthorizationService.isUserLoggedIn()) {
                    next({ name: 'login' })
                } else {
                    next()
                }
            }
        },
        {
            path: '/wachtwoord-herstellen',
            name: 'resetpassword',
            component: ResetPassword
        },
        {
            path: '/voorwaarden',
            name: 'terms',
            component: Terms
        },
        {
            path: '/veel-gestelde-vragen',
            name: 'faq',
            component: Faq
        },
        {
            path: '/Paginanietgevonden',
            name: 'pagenotfound',
            component: PageNotFound
        },
        {
            path: '/Foutcode500',
            name: 'InternalError',
            component: InternalError
        },
        {
            path: '*',
            name: '404',
            component: PageNotFound
        },
        {
            path: '/License',
            name: 'license',
            component: License
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js